/**
 * @module use-cases/slice/search
 * @desc Search Slice (Reducers and ExtraReducers)
 */

import { Utilities } from 'core/domains';
import { createSlice, REHYDRATE } from 'core/use-cases/utilities';

import { actions } from '../actions';
import { initialState } from './initial-state';

import type { RootState } from 'core';

const searchSlice = createSlice({
  name: 'search',
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder.addCase(actions.searchCleanUp, (state) => {
      state.data = [];
      state.isRunning = false;
      state.isSearchSubmit = false;
      state.message = '';
      state.notFound = false;
      state.status = Utilities.STATUS.IDLE;
      state.updatedAt = 0;
    });

    builder.addCase(actions.searchFetch.request, (state, { payload }) => {
      if (payload) {
        state.isRunning = true;
        state.isSearchSubmit = false;
        state.message = '';
        state.notFound = false;
        state.queryOptions.query = payload;
        state.status = Utilities.STATUS.RUNNING;
        state.updatedAt = 0;
      }
    });

    builder.addCase(actions.searchFetch.success, (state, { meta, payload }) => {
      const { data } = payload;

      state.data = data;
      state.isRunning = false;
      state.isSearchSubmit = false;
      state.message = '';
      state.notFound = !data.length;
      state.status = Utilities.STATUS.SUCCESS;
      state.updatedAt = meta.updatedAt;
    });

    builder.addCase(actions.searchFetch.failure, (state, { error }) => {
      const { message } = error;

      state.isRunning = false;
      state.isSearchSubmit = false;
      state.message = message;
      state.notFound = false;
      state.status = Utilities.STATUS.ERROR;
    });

    builder.addCase<string, { type: string; payload: RootState }>(
      REHYDRATE,
      (state, { payload = {} as RootState }) => {
        if (Object.keys(payload).length) {
          const {
            search: { isSearchSubmit, queryOptions },
          } = payload;

          state.isSearchSubmit = isSearchSubmit;
          state.queryOptions = queryOptions;

          state.data = [];
          state.isRunning = false;
          state.notFound = false;
          state.status = Utilities.STATUS.IDLE;
        }
      },
    );

    builder.addCase(actions.searchSubmit, (state) => {
      state.isSearchSubmit = true;
    });
  },
});

export const { reducer } = searchSlice;
